export const AODAddUserSupportedFormErrors = {
    DUPLICATE_VALUES: 'duplicateValues',
    INVALID_EMAILS: 'invalidEmails',
    MAX_LIMIT: 'maxLimit',
    NON_COMPANY_EMAILS: 'nonCompanyEmails',
    UNABLE_TO_VALIDATE_EMAIL: 'unableToValidateEmail'
};
